import React from 'react';
import { Box } from '@mui/material';
import { CreateForm, DEFAULT_ERROR_MESSAGE } from 'framework/form';
import { EducationInput, useEducationService } from 'domain/shared/employee';
import { usePrepopulationContext } from 'domain/people/employee/prepopulation/PrepopulationContext';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';
import { EducationCreateFormProps } from '../shared/types';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import FormActionButtons from '../../../shared/button/showEdit/FormActionButtons';

const EducationCreateForm: React.FC<EducationCreateFormProps> = ({ onSave, onCancel }) => {
  const { getValidationSchema, create } = useEducationService();
  const { addMessage } = useMessageService();

  const { data } = usePrepopulationContext();
  const handleSubmit = async (formData: FormFieldsData) => {
    try {
      await create({
        request: [formData],
      });
      return formData;
    } catch (error) {
      return addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
    }
  };

  const FormContent = () => {
    return (
      <Box display="flex" alignItems="flex-start" justifyContent="space-between">
        <Box width="100%">
          <EducationInput source="" />
        </Box>
        <FormActionButtons onCancel={onCancel} />
      </Box>
    );
  };

  return (
    <CreateForm
      getValidationSchemaFunc={getValidationSchema}
      submitFormFunc={handleSubmit}
      initialData={data}
      afterSubmit={{
        execute: onSave,
      }}
    >
      <FormContent />
    </CreateForm>
  );
};

export default EducationCreateForm;
